import styled from 'styled-components';

export const BackgroundColorWrapper = styled.div`
  width: 100%;
  background-color: ${props => props.theme.color[props.backgroundColor]};
  /* border-bottom: solid 1.5px ${props => props.theme.color.headerBorder}; */
`;

export const PaddedWrapper = styled.div`
  max-width: 101em;
  margin: 0 auto;
  padding: 0 1em;
`;
